// Аккордеон для FAQ-блоков (Landing/FAQAccordion и LandingSolo/FAQAccordion).
//
// В редакторе скрипт НЕ выполняется (карточки раскрыты по умолчанию, текст
// редактируется). При сохранении страницы скрипт добавляется в итоговый HTML —
// аналогично тому, как PageScriptEditor добавляет <script id="pageScript">.
//
// На живой странице скрипт:
//  - помечает каждый FAQ-блок классом `is-js` → карточки сворачиваются (CSS),
//  - по клику на заголовок переключает `is-open` у карточки (можно открывать
//    несколько одновременно),
//  - класс `is-ready` включает CSS-transition уже после первичного сворачивания,
//    чтобы при загрузке страницы не было «схлопывающейся» анимации.

const BLOCK_SELECTOR = ".landing-page-faq, .solo-landing-faq-accordion";
const HEADER_SELECTOR = ".landing-page-faq__header, .solo-landing-faq-accordion__header";

const FAQ_SCRIPT = `(function () {
  var BLOCKS = "${BLOCK_SELECTOR}";
  var HEADERS = "${HEADER_SELECTOR}";
  function init() {
    var blocks = document.querySelectorAll(BLOCKS);
    if (!blocks.length) return;
    for (var i = 0; i < blocks.length; i++) blocks[i].classList.add("is-js");
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        for (var j = 0; j < blocks.length; j++) blocks[j].classList.add("is-ready");
      });
    });
  }
  document.addEventListener("click", function (e) {
    var header = e.target && e.target.closest ? e.target.closest(HEADERS) : null;
    if (!header) return;
    var item = header.parentElement;
    if (item) item.classList.toggle("is-open");
  });
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", init);
  else init();
})();`;

export default function (editor) {
  editor.on("storage:start:store", data => {
    if (!data.html || typeof data.html !== "string") return;
    const hasFaq =
      data.html.indexOf("landing-page-faq") !== -1 || data.html.indexOf("solo-landing-faq-accordion") !== -1;
    const alreadyInjected = data.html.indexOf("faqAccordionScript") !== -1;
    if (!hasFaq || alreadyInjected) return;

    data.html = data.html + `<script id="faqAccordionScript">${FAQ_SCRIPT}</script>`;
  });
}
